<div [style.width]="width" id="TabSimple">
  <mat-tab-group
    (selectedTabChange)="tabChanged($event)"
    [selectedIndex]="selectedIndex"
  >
    <mat-tab
      [label]="label?.label"
      *ngFor="let label of labels"
      [disabled]="label?.disabled"
    ></mat-tab>
  </mat-tab-group>
</div>
